/**
 * Dev-mode flag resolution.
 *
 * Gates developer-only UI (the dev overlay, the auto-play toggle) on a per-viewer
 * basis. There is no auth, so the server can't tell the developer from a regular
 * player — viewer identity is a client-side fact. The default comes from the
 * server (`window.__DEV_MODE_DEFAULT__`, injected per Spring profile in game.html):
 * on off-prod, off on prod. A `?dev=1|0` URL param sets an explicit, persisted
 * override; otherwise a stored `localStorage.devMode` wins if present.
 *
 * Mirrors `isLearningMode()` in hints.js. Invariant: the resolved default is
 * NEVER written back — only an explicit `?dev=` param persists — so a regular
 * prod user (who never visits `?dev=`) never gets a devMode localStorage entry.
 */
export function isDevMode() {
  const param = new URLSearchParams(location.search).get("dev");
  if (param === "1" || param === "true") {
    localStorage.setItem("devMode", "true"); // explicit opt-in persists
    return true;
  }
  if (param === "0" || param === "false") {
    localStorage.setItem("devMode", "false"); // explicit opt-out persists
    return false;
  }
  const stored = localStorage.getItem("devMode");
  if (stored != null) return stored === "true";
  return window.__DEV_MODE_DEFAULT__ === true; // resolved default — never persisted
}
